export enum NativeModal {
  ORDER_SUMMARY = 'order-summary',
  TICKETS_DOWNLOAD = 'tickets-download',
  SEATING_PLAN = 'seating-plan',
  CONFIRM_RSVP = 'confirm-rsvp',
  HEADLESS_ERROR = 'headless-error',
}
